import { authService } from '@manager/api/services/auth-service';
import { useAuthStore } from '@manager/store/auth-store';
import memoize from 'memoize';

/**
 * Refetches `auth/user` into the auth store so `tenant_features.is_blocked_for_migration`
 * is current. A failed refresh keeps the existing user so a banner is never cleared by an error.
 */
export const refreshAuthUser = memoize(
  (): Promise<void> => {
    const authStore = useAuthStore();
    if (!authStore.isLoggedIn) {
      return Promise.resolve();
    }
    return authService
      .fetchUser()
      .then((response) => authStore.setUserData(response.data))
      .catch(() => undefined);
  },
  { maxAge: 5000 }
);
